import type { DelayedQuote } from '@benzinga/quotes-manager';

export const PRIVATE_MARKET_EXCHANGE = 'NPM';
export const PRIVATE_MARKET_EXCHANGE_LABEL = 'Nasdaq Private Market';

export const quoteExchangeLabel = (exchange?: string | null, isPrivate = false): string => {
  if (isPrivate || exchange === PRIVATE_MARKET_EXCHANGE) {
    return PRIVATE_MARKET_EXCHANGE_LABEL;
  }

  return exchange ?? '';
};

export const buildPrivateRichQuote = (
  symbol: string,
  lastPrice?: number,
  previousPrice?: number,
  companyName?: string,
): DelayedQuote => {
  const base = {
    bzExchange: PRIVATE_MARKET_EXCHANGE,
    ...(companyName
      ? {
          companyStandardName: companyName,
          name: companyName,
        }
      : {}),
    symbol,
  } as DelayedQuote;

  if (typeof lastPrice !== 'number' || !Number.isFinite(lastPrice)) {
    return base;
  }

  const previousClosePrice =
    typeof previousPrice === 'number' && Number.isFinite(previousPrice) ? previousPrice : lastPrice;
  const change = lastPrice - previousClosePrice;
  const changePercent = previousClosePrice ? (change / previousClosePrice) * 100 : 0;

  return {
    ...base,
    change,
    changePercent,
    close: lastPrice,
    lastTradePrice: lastPrice,
    previousClosePrice,
  };
};
